export default "__VITE_ASSET__ChpMakaS__"